<template>
	<div>
		<!-- Swap Dialog -->
		<modal class="swap-modal" size="small-medium" @close="close">
			<template slot="header">
				<h5 class="mb-0">{{ $t('Change Role') }}</h5>
			</template>
			<template slot="body">
				<div class="list-group list-feature-wrapper">
					<div class="list-group-item item-role-list text-decoration-none pointer" v-for="(item, index) in roles" :key="index" @click="selected(roles[index])">
						<div class="d-flex justify-content-between">
							<h5 class="mb-0 role-title">{{ formatText(roles[index]) }}</h5>
							<span v-if="roles[index] === role">
								<mdIcon>check</mdIcon>
							</span>
						</div>
					</div>
					<div v-if="!isFetching && user.roles.length === 0" class="text-center">
						{{ $t('You have not added any Features yet') }}
					</div>
				</div>
			</template>
			<div slot="footer">
				<div class="text-right">
					<button
						@click="switchRole()"
						:disabled="!role"
						type="submit"
						class="btn btn-submit btn-primary ml-1"
					>{{ $t('Switch Role') }}</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalChangeRole',
	components: {
		Modal,
	},
	props: {},
	mounted() {},
	data: () => ({
		isFetching: false,
		roles: null,
		role: '',
	}),
	methods: {
		...mapActions({
			setRole: 'setRole',
		}),
		close() {
			this.$emit('close');
		},
		selected(item) {
			this.role = item;
		},
		switchRole() {
			const role = this.role;
			this.setRole(role);
			this.$emit('close');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Role',
				text: 'Role has been changed',
			});
		},
		setDataRoles() {
			this.roles = JSON.parse(this.user.roles);
		},
		setCurrentRole() {
			this.role = this.currentRole;
		},
		formatText(str) {
			const text = str.split('_');
			let i = 0;
			for (i; i < text.length; i++) {
				text[i] = text[i].charAt(0).toUpperCase() + text[i].slice(1);
			}
			return text.join(' ');
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			currentRole: 'role',
		}),
	},
	created() {
		this.setDataRoles();
		this.setCurrentRole();
	},
};
</script>

<style lang="scss" scoped>
.material-icons-group {
	font-family: "Material Icons";
	font-weight: normal;
	font-style: normal;
	padding: 0px;
	margin: 0px;
	font-size: 80px;
	color: #ffa800;
	line-height: 1;
	letter-spacing: normal;
	text-transform: none;
	display: inline-block;
	white-space: nowrap;
	word-wrap: normal;
	direction: ltr;
	-webkit-font-feature-settings: "liga";
	-webkit-font-smoothing: antialiased;
}
.material-icons-swap {
	font-family: "Material Icons";
	position: rela;
	padding: 0px;
	margin: 0px;
	font-size: 60px;
	color: #ffa800;
	line-height: 1;
}
.wrapper-offline {
	text-align: center !important;
}
.item-role-list {
	min-height: 46px;
}
.role-title {
	position: relative;
	top: 3px;
}
</style>
